'use client';

import type { JSX } from 'react';

/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import React, { useCallback, useEffect } from 'react';
import { twMerge } from 'utilities/src/twMerge';
import useScrollLock from '../../hooks/useScrollLock';

type ModalComponentProps = {
  children: React.ReactNode;
  classes?: string;
  buttonClasses?: string;
  closeIcon: JSX.Element;
  onClose: () => void;
};

function ModalComponent({ children, classes, closeIcon, onClose, buttonClasses }: ModalComponentProps) {
  const { lockScroll, unlockScroll } = useScrollLock();

  const handleCloseModal = useCallback(() => {
    unlockScroll();
    onClose();
  }, [onClose, unlockScroll]);

  useEffect(() => {
    lockScroll();
  }, [lockScroll]);

  useEffect(() => {
    const handleEscKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        handleCloseModal();
      }
    };

    document.addEventListener('keydown', handleEscKey);

    return () => {
      document.removeEventListener('keydown', handleEscKey);
    };
  }, [handleCloseModal]);

  return (
    <div>
      <div className="fixed inset-0 z-[100] flex items-center justify-center">
        <div className="bg-site-neutrals-900 absolute inset-0 opacity-80" onClick={handleCloseModal} />
        <div className={twMerge('relative max-h-fit', classes)}>
          <button
            aria-label="Close"
            type="button"
            className={twMerge(
              buttonClasses ||
                'bg-site-primary-600 text-site-neutrals-0 absolute -top-[2.5rem] right-0 flex h-[2.5rem] items-center justify-center gap-1 px-2 py-1 font-medium before:content-["Close"]',
            )}
            onClick={handleCloseModal}
          >
            {closeIcon}
          </button>
          <div>{children}</div>
        </div>
      </div>
    </div>
  );
}

export default ModalComponent;
